import { serializeTokens } from './tokens'
import { SerializedPoolConfig, PoolCategory } from './types'

const serializedTokens = serializeTokens()
console.log(serializedTokens,"serializedTokens")
const pools: SerializedPoolConfig[] = [
  // {
  //   sousId: 0,
  //   stakingToken: serializedTokens.sparco,
  //   earningToken: serializedTokens.sparco,
  //   contractAddress: {
  //     97: '0xc864FBF36F7C32303111a2693841dFf0B222c3CF',
  //     56: '0x72f3504446332BF563e2dE2752cd4C5888Be0FC6',
  //   },
  //   poolCategory: PoolCategory.CORE,
  //   harvest: true,
  //   tokenPerBlock: '0.03805175038',
  //   sortOrder: 0,
  //   isFinished: false,
  // },
  {
    sousId: 1,
    stakingToken: serializedTokens.kings,
    earningToken: serializedTokens.kings,
    contractAddress: {
      97: '0xb1CBd81A3Da941a5c58882C99c2DeCd0571c1f65',
      56: '0x72f3504446332BF563e2dE2752cd4C5888Be0FC6',
    },
    poolCategory: PoolCategory.CORE,
    harvest: true,
    tokenPerBlock: '0.03805175038',
    sortOrder: 0,
    isFinished: false,
  }

]

export default pools
